module.exports = __webpack_public_path__ + "static/media/Slide1.e9944e42.jpg";